import { ILaya } from "../../ILaya";
import { AnimationStretchMode, FrameAnimation } from "../components/FrameAnimation";
import { HideFlags } from "../Const";
import { Sprite } from "../display/Sprite";
import { Event } from "../events/Event";
import { Loader } from "../net/Loader";
import { AtlasResource } from "../resource/AtlasResource";
import { Texture } from "../resource/Texture";
import { AlignType, LoaderFitMode, VAlignType } from "./Const";
import { GWidget } from "./GWidget";
import { ImageRenderer } from "./ImageRenderer";
export class GLoader extends GWidget {
    constructor() {
        super();
        this._frame = 0;
        this._autoPlay = true;
        this._loop = true;
        this._srcWidth = 0;
        this._srcHeight = 0;
        this._loadId = 0;
        this._src = "";
        this._color = "#ffffff";
        this._fitMode = LoaderFitMode.Contain;
        this._shrinkOnly = false;
        this._align = AlignType.Center;
        this._valign = VAlignType.Middle;
        this._content = new Sprite();
        this._content.hideFlags |= HideFlags.HideAndDontSave;
        this._renderer = new ImageRenderer(this._content);
        this._renderer._onReload = () => this.onTextureReload();
        this.addChild(this._content);
    }
    get src() {
        return this._src;
    }
    set src(value) {
        if (value == null)
            value = "";
        if (this._src == value)
            return;
        this._src = value;
        if (value)
            this.loadContent();
        else
            this.clearContent();
    }
    get icon() {
        return this._src;
    }
    set icon(value) {
        this.src = value;
    }
    get align() {
        return this._align;
    }
    set align(value) {
        if (this._align != value) {
            this._align = value;
            ILaya.timer.callLater(this, this.updateLayout);
        }
    }
    get valign() {
        return this._valign;
    }
    set valign(value) {
        if (this._valign != value) {
            this._valign = value;
            ILaya.timer.callLater(this, this.updateLayout);
        }
    }
    get fitMode() {
        return this._fitMode;
    }
    set fitMode(value) {
        if (this._fitMode != value) {
            this._fitMode = value;
            ILaya.timer.callLater(this, this.updateLayout);
        }
    }
    get shrinkOnly() {
        return this._shrinkOnly;
    }
    set shrinkOnly(value) {
        if (this._shrinkOnly != value) {
            this._shrinkOnly = value;
            ILaya.timer.callLater(this, this.updateLayout);
        }
    }
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
        this._renderer.setColor(value);
        if (this._ani)
            this._ani.color = this._ani.color.parse(value);
    }
    get ani() {
        return this._ani;
    }
    get frame() {
        return this._frame;
    }
    set frame(value) {
        this._frame = value;
        if (this._ani)
            this._ani.frame = value;
    }
    get autoPlay() {
        return this._autoPlay;
    }
    set autoPlay(value) {
        this._autoPlay = value;
        if (this._ani)
            this._ani.autoPlay = value;
    }
    get loop() {
        return this._loop;
    }
    set loop(value) {
        this._loop = value;
        if (this._ani)
            this._ani.loop = value;
    }
    get texture() {
        return this._renderer._tex;
    }
    set texture(value) {
        this._src = "instance-0";
        this.onLoaded(value, ++this._loadId);
    }
    get mesh() {
        return this._renderer._meshFactory;
    }
    set mesh(value) {
        this._renderer.setMesh(value);
    }
    get material() {
        return this._content.material;
    }
    set material(value) {
        this._content.material = value;
    }
    loadContent() {
        let loadID = ++this._loadId;
        let res = Loader.getRes(this._src, Loader.IMAGE);
        if (!res)
            ILaya.loader.load(this._src, { maybeType: Loader.IMAGE }).then(res => this.onLoaded(res, loadID));
        else
            this.onLoaded(res, loadID);
    }
    onLoaded(value, loadID) {
        if (this._loadId != loadID || this.destroyed)
            return;
        if (value instanceof Texture) {
            if (this._ani)
                this._ani.setAtlas(null);
            this._renderer.setTexture(value);
            this._srcWidth = value.sourceWidth;
            this._srcHeight = value.sourceHeight;
        }
        else if (value instanceof AtlasResource) {
            this._renderer.setTexture(null);
            if (!this._ani) {
                this._ani = this._content.addComponent(FrameAnimation);
                this._ani.color = this._ani.color.parse(this._color);
                this._ani.stretchMode = AnimationStretchMode.Fill;
                this._ani.autoPlay = this._autoPlay;
                this._ani.loop = this._loop;
                this._ani.frame = this._frame;
            }
            this._ani.setAtlas(value);
            this._srcWidth = this._ani.width;
            this._srcHeight = this._ani.height;
        }
        else {
            this._renderer.setTexture(null);
            if (this._ani)
                this._ani.setAtlas(null);
            this._srcWidth = 0;
            this._srcHeight = 0;
        }
        ILaya.timer.runCallLater(this, this.updateLayout, true);
        this.event(Event.LOADED);
    }
    onTextureReload() {
        let tex = this._renderer._tex;
        this._srcWidth = tex.sourceWidth;
        this._srcHeight = tex.sourceHeight;
        ILaya.timer.runCallLater(this, this.updateLayout, true);
        this.event(Event.LOADED);
    }
    clearContent() {
        this._srcWidth = 0;
        this._srcHeight = 0;
        this._loadId++;
        this._renderer.setTexture(null);
        if (this._ani)
            this._ani.source = null;
    }
    updateLayout() {
        let cw = this._srcWidth, ch = this._srcHeight;
        if (cw == 0 || ch == 0)
            return;
        this._updatingLayout = true;
        let sx = 1, sy = 1;
        if (this._fitMode != LoaderFitMode.None && cw != 0 && ch != 0) {
            sx = this.width / cw;
            sy = this.height / ch;
            if (sx != 1 || sy != 1) {
                if (this._fitMode == LoaderFitMode.CoverHeight)
                    sx = sy;
                else if (this._fitMode == LoaderFitMode.CoverWidth)
                    sy = sx;
                else if (this._fitMode == LoaderFitMode.Contain) {
                    if (sx > sy)
                        sx = sy;
                    else
                        sy = sx;
                }
                else if (this._fitMode == LoaderFitMode.Cover) {
                    if (sx > sy)
                        sy = sx;
                    else
                        sx = sy;
                }
                if (this._shrinkOnly) {
                    if (sx > 1)
                        sx = 1;
                    if (sy > 1)
                        sy = 1;
                }
                cw = cw * sx;
                ch = ch * sy;
            }
        }
        this._content.size(cw, ch);
        let nx, ny;
        if (this._align == AlignType.Center)
            nx = Math.floor((this.width - cw) / 2);
        else if (this._align == AlignType.Right)
            nx = this.width - cw;
        else
            nx = 0;
        if (this._valign == VAlignType.Middle)
            ny = Math.floor((this.height - ch) / 2);
        else if (this._valign == VAlignType.Bottom)
            ny = this.height - ch;
        else
            ny = 0;
        this._content.pos(nx, ny);
        this._updatingLayout = false;
    }
    _sizeChanged() {
        super._sizeChanged();
        if (!this._updatingLayout)
            ILaya.timer.callLater(this, this.updateLayout);
    }
    destroy() {
        super.destroy();
        this._renderer.destroy();
    }
}
